export default __webpack_public_path__ + "static/media/searching.a017e96c.png";